module.exports = __webpack_public_path__ + "static/media/cu.28ccb9c8.svg";